module.exports = {"340827100":"华阳镇","340827101":"杨湾镇","340827102":"漳湖镇","340827103":"赛口镇","340827104":"高士镇","340827105":"鸦滩镇","340827106":"长岭镇","340827107":"太慈镇","340827200":"凉泉乡","340827201":"雷池乡","340827400":"望江县经济开发区","340827401":"安徽望江桥港经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340827.json
// module id = 1098
// module chunks = 0